import HttpResponse from "../../../../../../utils/http/http.response";

export enum BillingsPlanEntryRelatedTaxiTaxiResponseContractBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export enum BillingsPlanEntryRelatedTaxiTaxiResponseDataBillingStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPEN_REQUEST = "REOPEN_REQUEST",
  REOPENED = "REOPENED",
}

export type BillingsPlanEntryRelatedTaxiTaxiResponseDataConsumerTaxi = {
  displayName: string;
};

export type BillingsPlanEntryRelatedTaxiTaxiResponseDataContract = {
  consumerTaxi: BillingsPlanEntryRelatedTaxiTaxiResponseDataConsumerTaxi;
  distanceRate: number;
  model: BillingsPlanEntryRelatedTaxiTaxiResponseContractBillingModel;
};

export type BillingsPlanEntryRelatedTaxiTaxiResponseDataCargoOrder = {
  humanId: number;
};

export type BillingsPlanEntryRelatedTaxiTaxiResponseDataTransportingOrder = {
  cargoOrder: BillingsPlanEntryRelatedTaxiTaxiResponseDataCargoOrder;
};

export type BillingsPlanEntryRelatedTaxiTaxiResponseDataOrderForwardingAction =
  {
    id: string;
    contract: BillingsPlanEntryRelatedTaxiTaxiResponseDataContract;
    transportingOrder: BillingsPlanEntryRelatedTaxiTaxiResponseDataTransportingOrder;
  };

export type BillingsPlanEntryRelatedTaxiTaxiResponseData = {
  id: string;
  draft: boolean;
  distance: number;
  amountForChargeHighways: number | null;
  amountForChargeHaltings: number | null;
  allContributionsAmount: number | null;
  amountForDistance: number | null;
  date: Date;
  orderForwardingAction: BillingsPlanEntryRelatedTaxiTaxiResponseDataOrderForwardingAction;
  sumOfBonuses: number;
  sumOfPenalties: number;
  status: BillingsPlanEntryRelatedTaxiTaxiResponseDataBillingStatus;
  readOnly: boolean;
};

type BillingsPlanEntryRelatedTaxiTaxiResponse = HttpResponse<
  BillingsPlanEntryRelatedTaxiTaxiResponseData[]
>;

export default BillingsPlanEntryRelatedTaxiTaxiResponse;
